<template>
  <div class="d-flex flex-column align-items-center justify-content-center" :class="status">
    <div class="check">
      <div class="out-circle">
        <div class="in-circle d-flex align-items-center justify-content-center">
          <Icon v-if="status == 'done'" icon="bootstrap-check" :width="16" :height="16" />
          <Icon v-if="status == 'actual'" icon="bootstrap-dot" :width="16" :height="16" />
        </div>
      </div>
    </div>
    <div class="text"><slot></slot></div>
  </div>
</template>

<script>
import Icon from 'UI/Icon';
export default {
  components: {
    Icon
  },
  props: {
    status: {
      type: String,
      required: false,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.5;
}
.text {
  font-size: 12px;
}
.check {
  .out-circle {
    background-color: #4086fe;
    padding: 5px;
    border-radius: 20px;
  }
  .in-circle {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background-color: #3e68ff;
  }
}
</style>
